var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"haizol-page-broadcast"},[_c('i',{staticClass:"iconfont icon-icon-new"}),_c('span',{staticClass:"broadcast-msg"},[_vm._v(_vm._s(_vm.msg))]),_c('i',{staticClass:"el-icon-close broadcast-close",on:{"click":function($event){return _vm.$emit('close')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }